// extracted by mini-css-extract-plugin
export default {"expert":"JnQcf1bD","withoutJobTitle":"aKkL7xAa","authorInfo":"w3mFk686","avatar":"cjGUY85a"};